import { SUBSCRIPTION_API } from '../api';

const SubscriptionService = {

    getSubscription: async (token) => {
        const { data } = await SUBSCRIPTION_API.get(`${token}`);
        return data;
    },

    confirm: async (token, input) => {
        const { data } = await SUBSCRIPTION_API.post(`${token}/confirm`, input);
        return data;
    },

    cancel: async (token, input, headers) => {
        const { data } = await SUBSCRIPTION_API.post(`${token}/cancel`, input, { headers: headers });
        return data;
    },

};

export default SubscriptionService;
